export default "__VITE_ASSET__01a73db5__"